import appStore from 'store';
import api from './api';

const store = {
  namespaced: true,
  state: {
    infoListData:[],   //盒子列表
    pagination: {
      page: 1,
      size: 10
    },
    total: 0
  },
  getters: {

  },
  mutations: {
    infoList(state, data) {
      state.infoListData = data;
    },
    setPagination(state, payload) {
      state.pagination = payload
    },
    setTotal(state, payload) {
      state.total = payload
    }
  },
  actions: {
    //订单列表
    getinfoList({ commit }, data) {
      api.getTipsList(data).then(res => {
        let records = res.data.records;
        records.forEach(item => {
          item.withdrawPrompt = JSON.parse(item.withdrawPrompt)
          item.tipsObj = item.withdrawPrompt
          item.nameObj = Object.keys(item.withdrawPrompt).map(v => ({lang: v, name: item.withdrawPrompt[v]}))
          const array = Object.keys(item.withdrawPrompt).map(v => (item.withdrawPrompt[v] ? v : ''))
          const filtered = array.filter((el) => {
            return el != '';
          });
          item.languageObj = filtered
        });
        commit('infoList', res.data.records);
        commit('setTotal', res.data.total)
        commit('setPagination', { page: data.page, size: data.size })
      });
    },

  }
};
appStore.registerModule('withdrawInfo', store);
